import React, {useRef, useCallback, useMemo} from 'react';
import {ScrollView} from 'react-native';

type UseScrollType = () => {
  scrollRef: React.RefObject<ScrollView | null>;
  scrollTo: (y: number) => void;
};

export const useScroll: UseScrollType = () => {
  const scrollRef = useRef<ScrollView>(null);

  const scrollTo = useCallback((y: number) => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({y});
    }
  }, []);

  return useMemo(() => ({scrollRef, scrollTo}), [scrollRef, scrollTo]);
};
